export default __webpack_public_path__ + "static/media/manual-preview-hover.840ef559.png";